/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { RateDetailsDto } from './rateDetailsDto';


export interface ServiceRate { 
    id?: string;
    rateId?: string;
    serviceProviderName?: string;
    serviceProviderId?: string;
    name?: string;
    currency: number;
    createdOn: Date;
    effectiveDate: Date;
    terminationDate: Date;
    isDedicated: boolean;
    isDeleted: boolean;
    rateDetails?: Array<RateDetailsDto>;
}
